import React, { useState, useEffect } from 'react';
import './OrderPage.css';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useProjects } from '../hooks/useProjects';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { useQuery } from 'react-query';
import { selectAllProjects, selectProjectsStatus, selectProjectsError } from '../features/projectsSlice';

const OrderPage = ({ userId, role }) => {
  const { isLoading, isError, error, data } = useProjects(userId, role);
  const projects = useSelector(selectAllProjects);
  const status = useSelector(selectProjectsStatus);
  const reduxError = useSelector(selectProjectsError);
 

  const [activeFilter, setActiveFilter] = useState('all');
  const [orders, setOrders] = useState([
    { id: '121 091', created: 'Aug 1, 2019', customer: 'Harriet Santiago', fulfillment: 'Unfulfilled', total: '$604.50', profit: '$182.50', status: 'Authorized', updated: 'Today', isActive: true, isPaid: false },
    { id: '121 090', created: 'Jul 21, 2019', customer: 'Sara Graham', fulfillment: 'Pending Receipt', total: '$1,175.50', profit: '$524.25', status: 'Paid', updated: 'Today', isActive: true, isPaid: true },
    { id: '121 090', created: 'Jul 21, 2019', customer: 'Sara Graham', fulfillment: 'Pending Receipt', total: '$1,175.50', profit: '$524.25', status: 'Paid', updated: 'Today', isActive: true, isPaid: true },
    { id: '121 090', created: 'Jul 21, 2019', customer: 'Sara Graham', fulfillment: 'Pending Receipt', total: '$1,175.50', profit: '$524.25', status: 'Paid', updated: 'Today', isActive: true, isPaid: true },
    { id: '121 090', created: 'Jul 21, 2019', customer: 'Sara Graham', fulfillment: 'Pending Receipt', total: '$1,175.50', profit: '$524.25', status: 'Paid', updated: 'Today', isActive: true, isPaid: true },
    // Add more order data...
  ]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);


  useEffect(() => { 
    // fetchOrders(currentPage);
  }, [currentPage, activeFilter]);

  // const fetchOrders = async (page) => {

  //   try {
  //     const response = await fetch(`https://api-4h4srbodqa-uc.a.run.app/?page=${page}&filter=${activeFilter}`);
  //     const data = await response.json();
  //     setOrders(data.projects);
  //     setTotalPages(data.totalPages);
  //   } catch (error) {
  //     console.error("Error fetching orders:", error);
  //   }
  
  // };

  const handleFilterChange = (filter) => {
    setActiveFilter(filter);
    setCurrentPage(1);
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const filteredOrders = orders.filter(order => {
    switch(activeFilter) {
      case 'active':
        return order.isActive;
      case 'unpaid':
        return !order.isPaid;
      case 'unfulfilled':
        return order.fulfillment === 'Unfulfilled';
      default:
        return true;
    }
  });

  console.log("data checking", data);
  console.log("project data checknih", projects);

  const projectsToRender = projects.length > 0 ? projects : data;

  return (
    <div className="orders-page">
      {/* <Header /> */}
      <div>
        {/* <div className="orders-header">
          <h1>Project list</h1>
          <button className="create-order-btn">Create order</button>
        </div> */}
        {/* <OrderSummaryCards orders={orders} /> */}
        <OrderListFilters activeFilter={activeFilter} onFilterChange={handleFilterChange} />
        {isLoading ? (
          <p>Loading...</p>
        ) : (
          <>
            <OrderTable orders={projectsToRender} />
            <Pagination
              currentPage={currentPage}
              totalPages={totalPages}
              onPageChange={handlePageChange}
            />
          </>
        )}
      </div>
    </div>
  );
};
// const Header = () => {
//   return (
//     <header>
//       <nav>
//         <ul>
//           <li><a href="#dashboard">Dashboards</a></li>
//           <li><a href="#orders" className="active">Orders</a></li>
//           <li><a href="#customers">Customers</a></li>
//           <li><a href="#inventory">Inventory</a></li>
//           <li><a href="#settings">Settings</a></li>
//         </ul>
//       </nav>
//       <div className="user-profile">
//         {/* Add notification icon and user avatar */}
//       </div>
//     </header>
//   );
// };

export const OrderSummaryCards = () => {
  const summaries = [
    { title: 'Active Projects', count: 1046, color: 'blue' },
    { title: 'Completed Projects', count: 159, color: 'yellow' },
    { title: 'Pending Rece...', count: 624, color: 'purple' },
    { title: 'Total Projects', count: 263, color: 'green' },
  ];

  return (
    <div className="order-summary-cards">
      {summaries.map((summary, index) => (
        <div key={index} className={`summary-card ${summary.color}`}>
          <h3>{summary.title}</h3>
          <p className="count text-dark">{summary.count}</p>
          {/* Add mini chart here */}
        </div>
      ))}
    </div>
  );
};

const OrderListFilters = ({ activeFilter, onFilterChange }) => {
    return (
      <div className="order-list-filters">
        <ul>
          <li 
            className={activeFilter === 'all' ? 'active' : ''}
            onClick={() => onFilterChange('all')}
          >
            All orders
          </li>
          <li 
            className={activeFilter === 'active' ? 'active' : ''}
            onClick={() => onFilterChange('active')}
          >
            Active
          </li>
          <li 
            className={activeFilter === 'unpaid' ? 'active' : ''}
            onClick={() => onFilterChange('unpaid')}
          >
            Unpaid
          </li>
          <li 
            className={activeFilter === 'unfulfilled' ? 'active' : ''}
            onClick={() => onFilterChange('unfulfilled')}
          >
            Unfulfilled
          </li>
        </ul>
        <input type="search" placeholder="Search..." />
      </div>
    );
  };


  
  // Function to get stage info
  const getStageInfo = (step) => {
    const stages = [
      { name: 'Sales Stage', color: '#FFD700' },     // Gold
      { name: 'Design Stage', color: '#87CEEB' },    // Sky Blue
      { name: 'Execution', color: '#FFA500' },       // Orange
      { name: 'Completed', color: '#32CD32' }        // Lime Green
    ];
    
    // Ensure step is a number and within valid range
    const numStep = Number(step);
    const index = !isNaN(numStep) ? Math.min(Math.max(0, numStep - 1), stages.length - 1) : 0;
    return stages[index];
  };
  
  const OrderTable = ({ orders }) => {
    const navigate = useNavigate();
  
    const handleRowClick = (order) => {
      // Navigate to a different page
      // navigate(`/project/${orderId}`);
       navigate(`/project/${order.id}`, { state: { order } });
      
      // Alternatively, if you want to render a child component instead,
      // you can use state or context to show the child component
      // and pass the orderId to it.
    };
  
    return (
      <table className="order-table">
        <thead>
          <tr>
            <th>Project ID</th>
            <th>Project Name</th>
            <th>Customer Name</th>
            <th>Closure Date</th>
            <th>Stage</th>
            <th>Collaborators</th>
            <th>Last Note</th>
          </tr>
        </thead>
        <tbody>
          { orders ? orders.map((order) => (
            <tr 
              key={order.id} 
              onClick={() => handleRowClick(order)}
              style={{ cursor: 'pointer' }}
            >
              <td>{order.id}</td>
              <td>{order.name}</td>
              <td>{order.clientName}</td>
              <td>{order.closureDate}</td>
              <td>
            {(() => {
              console.log('Steps value:', order.steps); // For debugging
              const stageInfo = getStageInfo(order.steps);
              return (
                <span style={{ 
                  backgroundColor: stageInfo ? stageInfo.color : '#gray', 
                  padding: '4px 8px', 
                  borderRadius: '12px',
                  color: 'white',
                  fontWeight: 'bold'
                }}>
                  {stageInfo ? stageInfo.name : 'Unknown Stage'}
                </span>
              );
            })()}
          </td>
          <td>
  {order.assignments ? (
    Object.values(order.assignments).map((role, index) => (
      <span
        key={index}
        style={{
          display: 'inline-block',
          width: '24px',
          height: '24px',
          borderRadius: '50%',
          backgroundColor: '#e66000',
          color: 'white',
          textAlign: 'center',
          lineHeight: '24px',
          margin: '0 2px',
          fontSize: '12px',
          fontWeight: 'bold',
        }}
        title={role.displayName}
      >
        {role.displayName?.charAt(0).toUpperCase()}
      </span>
    ))
  ) : (
    <span>No collaborators</span>
  )}
</td>

    
              
              
              <td>{order.description}</td>
            </tr>
          ))  : null}
        </tbody>
      </table>
    );
  };

  const Pagination = ({ currentPage, totalPages, onPageChange }) => {
    return (
      <div className="pagination">
        <button 
          onClick={() => onPageChange(currentPage - 1)} 
          disabled={currentPage === 1}
        >
          Previous
        </button>
        <span>{currentPage} of {totalPages}</span>
        <button 
          onClick={() => onPageChange(currentPage + 1)} 
          disabled={currentPage === totalPages}
        >
          Next
        </button>
      </div>
    );
  };
  
  export default OrderPage;
